import { ref, onMounted } from 'vue'

import type CommonInput from '@components/common/CommonInput.vue'

/**
 * Shared boilerplate for wrappers around CommonInput:
 *  - element ref
 *  - checkFullValidation / focus passthroughs
 *  - optional onMounted emit
 */
export const useInputWrapper = (emitMounted?: () => void) => {
  const commonInputEl = ref<InstanceType<typeof CommonInput> | null>(null)

  const checkFullValidation = () => {
    commonInputEl.value?.checkFullValidation()
  }

  const focus = () => {
    commonInputEl.value?.focus()
  }

  if (emitMounted) {
    onMounted(emitMounted)
  }

  return { commonInputEl, checkFullValidation, focus }
}
